import React from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { useTheme, ThemeMode } from '../contexts/ThemeContext';
import IconButton from './common/IconButton';
import { ICONS } from '../utils/fontAwesome';

const ThemeSwitch: React.FC = () => {
  const { mode, setTheme } = useTheme();

  const buttons: Array<{
    mode: ThemeMode;
    icon: IconProp;
    label: string;
  }> = [
    { mode: 'dark', icon: ICONS.MOON, label: 'Dark' },
    { mode: 'light', icon: ICONS.SUN, label: 'Light' },
    { mode: 'auto', icon: ICONS.ADJUST, label: 'Auto' },
  ];

  return (
    <div className="flex items-center space-x-1">
      {buttons.map(({ mode: buttonMode, icon, label }) => (
        <IconButton
          key={buttonMode}
          icon={icon}
          onClick={() => setTheme(buttonMode)}
          active={mode === buttonMode}
          title={label}
          aria-label={label}
        />
      ))}
    </div>
  );
};

export default ThemeSwitch;